import React from 'react'
import Transactions from '../Components/Transactions'

function TransactionsPage() {
  return (
    <div className="bg-gradient-to-r from-blue-300 to-blue-400"><Transactions/></div>
  )
}

export default TransactionsPage